/**
 * Utility
 */

var Utility = Utility || {};

/**
 * ペーストをされた場合に表示
 *
 * @param  {string} target
 */
Utility.disablePaste = function(target) {
	jQuery(function($) {
		var $popover = $(target).popover({
			html: true,
			content: 'この項目は貼り付け出来ません。<br />お手数ですが、再度入力してください。',
			placement: 'bottom',
			trigger: 'focus',
		}).
		on('hidden.bs.popover', function() {
			$(target).popover('destroy');
		})
		.popover('show');
	});
}

/**
 * 全角を半角へ変換
 *
 * @param  {string} string
 * @return {string}
 */
Utility.zenToHan = function(string) {
	return string.replace(/[！-～]/g, function(s) {
		return String.fromCharCode(s.charCodeAt(0)-0xFEE0);
	});
};

/**
 * 電話番号にハイフンを付ける
 *
 * @param  {string} string
 * @return {string}
 */
Utility.addTelHyphen = function(string) {
	string = String(string);
	return string.replace(/(\d+)(\d{4})(\d{4})$/g, "$1" + "-" + "$2" + "-" + "$3");
}

/**
 * 長音等をハイフンに変換
 *
 * @param  {string} string
 * @return {string}
 */
Utility.convertHyphen = function(string) {
	string = String(string);
	return string.replace(/(−|ｰ|ー|—)/g, '-');
}

/**
 * Cookieに保存されている金額表示のフラグ
 *
 * @return {boolean}
 */
Utility.isVisiblePrice = function() {
	if ($.cookie(__visiblePriceKey) === 'false') {
		return false;
	}

	return true;
};

/**
 * ドメインの確認
 * @param {string} email メールアドレス
 * @return {Promise}
 */
Utility.isValidDomain = function (email) {
	var defer = $.Deferred();
	var ajax = $.ajax({
		url: '/service/is-valid-domain.json',
		method: 'GET',
		cache: false,
		data: {
			email: email,
		},
		success: defer.resolve,
		error: defer.reject
	});

	return defer.promise();
};